(function () {
    'use strict';

    angular.module("imApp").factory("shopFloorService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3680,
                    parameters: parms || {}
                });
            },
            listLabours: function (parms) {
                return $ihttp.post({
                    method: 121,
                    parameters: parms || {}
                });
            },
            getSelectedJob: function (setting) {
                return $ihttp.post({
                    method: 3685,
                    parameters: setting
                });
            },
            startSelectedJob: function (setting) {
                return $ihttp.post({
                    method: 3686,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
